import { render } from "./MonthPager.vue?vue&type=template&id=6ece67e2&scoped=true&ts=true"
import script from "./MonthPager.vue?vue&type=script&lang=ts"
export * from "./MonthPager.vue?vue&type=script&lang=ts"

import "./MonthPager.vue?vue&type=style&index=0&id=6ece67e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ece67e2"]])

export default __exports__